export * from './resource-card';